export default __webpack_public_path__ + "locales/help.ru.json";